// List cars makes. Imports list of cars makes from data file
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { serverURL } from '../helpers/dataServerURL';
import styles from '../css/carMakes.module.css';
import CarMakesLettersBtns from '../components/carMakesLettersBtns';
import { useNavigate } from 'react-router-dom';

let frequentCarMakesList = [];
export default function CarMakes({ closeScreen }) {
  const [frequentCarMakes, setFrequentCarMakes] = useState([]);

  const logInURL = serverURL.server.url;
  const [carMakes, setCarMakes] = useState([]);
  const isScreenLoadedRef = useRef(true);

  useEffect(() => {
    fetchFrequentCarMakes();
  }, []);

  const navigate = useNavigate();

  //   Fetch all car makes on component mount

  //   useEffect(() => {
  //     fetchCarMakesByLetter('A', 'F');
  //   }, []);

  let startLetter;
  let endLetter;

  function handleLetterClick(e) {
    startLetter = e.currentTarget.textContent.charAt(0);
    endLetter = e.currentTarget.textContent.charAt(4);
    fetchCarMakesByLetter(startLetter, endLetter);
    isScreenLoadedRef.current = false;
  }

  // const fetchCarMakes = async () => {
  //   try {
  //     const response = await axios.get(`${logInURL}/carMakes/carMakesList`);
  //     if (response.data) {
  //       setCarMakes(response.data);
  //       console.log(response.data, 'car makes');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching car makes:', error);
  //   }
  // };

  //   List of car makes by starting letters api
  async function fetchCarMakesByLetter(letter1, letter2) {
    try {
      const response = await axios.get(`${logInURL}/carMakes/carMakesByLetters/${letter1}&${letter2}`);
      if (response.data) {
        setCarMakes(response.data);
      }
    } catch (error) {
      console.error('Error fetching car makes by letters:', error);
    }
  }

  // Function call to fetch all car makes that are frequently used
  async function fetchFrequentCarMakes() {
    try {
      const response = await axios.get(`${logInURL}/carMakes/frequentCars`);
      if (response.data.length > 0) {
        frequentCarMakesList = response.data.map((car) => car.Make);
        setFrequentCarMakes(frequentCarMakesList);
      }
    } catch (error) {
      console.error('Error fetching frequent car makes:', error);
    }
  }

  return (
    <div>
      <CarMakesLettersBtns
        fetchCarMakesByLetter={handleLetterClick}
        startLetter={startLetter}
        endLetter={endLetter}
        carMakesList={carMakes}
        // setIsFrequentCarScreenLoaded={
        //   setIsFrequentCarScreenLoaded
        // }
      >
        <div className={styles.carMakesContainer}>
          {carMakes.map((make, id) => (
            <button
              key={make.id}
              className={styles.carMakeItem}
              type="button"
              onClick={() => {
                closeScreen();
                navigate('/ticketEntry', {
                  state: {
                    selectedCarMake: make.Make,
                  },
                });
              }}
            >
              {make.Make}
            </button>
          ))}
        </div>
      </CarMakesLettersBtns>
      <div
        className={styles.frequentCarMakesContainer}
        style={isScreenLoadedRef.current === false ? { display: 'none' } : { display: 'block' }}
      >
        {frequentCarMakesList.length > 0 &&
          frequentCarMakes.map((make, id) => (
            <button
              key={make.id}
              className={styles.frequentCarMakeBtn}
              onClick={() => {
                closeScreen();
                navigate('/ticketEntry', {
                  state: {
                    frequentCar: make,
                  },
                });
              }}
              type="button"
            >
              {make}
            </button>
          ))}
      </div>
      {/* {console.log(
        isFrequentCarScreenLoaded,
        'frequent car screen loaded'
      )} */}
    </div>
  );
}
